import React from "react";
import { Navigate, NavLink, Route, Routes } from "react-router-dom";
import Navbar from "../../Components/Navigation/Navbar";
import EventManagement from "./EventPlaner";
import AlbumManager from "../../Components/admin/albummanager";
import BlogAdmin from "../../Components/admin/blogadmin";
import WorkHoursAdmin from "../../Components/admin/workhoursadmin";
import AssetBookingsAdmin from "../../Components/admin/assetbookingsadmin";
import "./admin.css";

const sections = [
    { to: "/admin/home/events", label: "Events", description: "Termine, Sichtbarkeit und Anhänge verwalten" },
    { to: "/admin/home/albums", label: "Alben", description: "Galerien, Metadaten und Bilder organisieren" },
    { to: "/admin/home/blogs", label: "Blogs", description: "Neuigkeiten verfassen und veröffentlichen" },
    { to: "/admin/home/workhours", label: "Arbeitsstunden", description: "Eingereichte Arbeitsstunden prüfen" },
    { to: "/admin/home/materialverleih", label: "Materialverleih", description: "Ausleihen prüfen und verwalten" },
];

function Dashboard() {
    return (
        <section aria-labelledby="admin-dashboard-title">
            <div className="admin-page-heading">
                <div>
                    <p className="admin-eyebrow">Übersicht</p>
                    <h1 id="admin-dashboard-title">Adminbereich</h1>
                    <p>Wähle einen Bereich, um Inhalte und Vereinsdaten zu verwalten.</p>
                </div>
            </div>
            <div className="admin-dashboard-grid">
                {sections.map((section) => (
                    <NavLink className="admin-dashboard-card" to={section.to} key={section.to}>
                        <span className="admin-dashboard-card__title">{section.label}</span>
                        <span>{section.description}</span>
                        <span className="admin-dashboard-card__action" aria-hidden="true">Öffnen →</span>
                    </NavLink>
                ))}
            </div>
        </section>
    );
}

export function AdminPage() {
    return (
        <>
            <Navbar />
            <main className="admin-shell">
                <div className="admin-shell__topbar">
                    <NavLink to="/admin/home" className="admin-brand">Verwaltung</NavLink>
                    <nav className="admin-nav" aria-label="Adminbereiche">
                        {sections.map((section) => (
                            <NavLink
                                key={section.to}
                                to={section.to}
                                className={({ isActive }) => `admin-nav__link${isActive ? " is-active" : ""}`}
                            >
                                {section.label}
                            </NavLink>
                        ))}
                    </nav>
                </div>
                <div className="admin-content">
                    <Routes>
                        <Route index element={<Dashboard />} />
                        <Route path="events" element={<EventManagement />} />
                        <Route path="albums" element={<AlbumManager />} />
                        <Route path="blogs" element={<BlogAdmin />} />
                        <Route path="workhours" element={<WorkHoursAdmin />} />
                        <Route path="materialverleih" element={<AssetBookingsAdmin />} />
                        <Route path="material-ausleih" element={<Navigate to="/admin/home/materialverleih" replace />} />
                        <Route path="asset-bookings" element={<Navigate to="/admin/home/materialverleih" replace />} />
                        <Route path="*" element={<Dashboard />} />
                    </Routes>
                </div>
            </main>
        </>
    );
}

export default AdminPage;
